const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled,
	ToggleControl,
	RangeControl,
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/gallery", {
	title: __("Galerie d'images", "wp-apidae"), // Block title.
	description: __("Affiche les images et un système de diaporama de la fiche.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.gallery
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
		attributes:{
			main_image_size: 'thumbnail',
			thumbnails_size: 'thumbnail',
		}
  },
	attributes: {
		main_image: {
			type: "boolean",
			default: true,
		},
		main_image_size: {
			type: 'string',
			default: 'full',
		},
		thumbnails: {
			type: "boolean",
			default: true,
		},
		thumbnails_size: {
			type: 'string',
			default: 'full',
		},
		limit_thumb: {
			type: 'number',
			default: 2,
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const imageSizes         = window.WpApidaeTemplateData.imageSizes;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
						<ToggleControl
								label={ __( 'Image principale' ) }
								checked={ attributes.main_image }
								onChange={ () => {
									props.setAttributes({ main_image: ! attributes.main_image });
								} }
							/>
							{true == attributes.main_image &&
							<SelectControl
								label={ __( 'Taille image principale' ) }
								value={ attributes.main_image_size }
								options={imageSizes}
								onChange={ newValue => {
									props.setAttributes({
										main_image_size: newValue,
									});
								}}
							/>
							}
						<ToggleControl
								label={ __( 'Autres images' ) }
								checked={ attributes.thumbnails }
								onChange={ () => {
									props.setAttributes({ thumbnails: ! attributes.thumbnails });
								} }
							/>
							{true == attributes.thumbnails &&
							<>
							<SelectControl
								label={ __( 'Taille autres images' ) }
								value={ attributes.thumbnails_size }
								options={imageSizes}
								onChange={ newValue => {
									props.setAttributes({
										thumbnails_size: newValue,
									});
								}}
							/>
							<RangeControl
								label={__("Nombre de miniatures", "wp-apidae")}
								value={attributes.limit_thumb}
								onChange={newValue => {
									props.setAttributes({
										limit_thumb: newValue,
									});
								}}
								min={1}
								max={10}
							/>
							</>
							}
						</PanelBody>
					</InspectorControls>,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/gallery"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
